export const PWA_UPDATE_EVENT = "family-gifts:pwa-update";

export interface PwaUpdateEventDetail {
  applyUpdate: () => Promise<void>;
}

let pendingUpdate: PwaUpdateEventDetail | null = null;

export function publishPwaUpdate(detail: PwaUpdateEventDetail): void {
  pendingUpdate = detail;
  window.dispatchEvent(
    new CustomEvent<PwaUpdateEventDetail>(PWA_UPDATE_EVENT, { detail }),
  );
}

export function getPendingPwaUpdate(): PwaUpdateEventDetail | null {
  return pendingUpdate;
}
